import { EDITOR } from '../../config/constants';
import getContext from './get-context';

const inGuidebookContext = state =>
  getContext(state) === undefined || getContext(state) === EDITOR;

export default inGuidebookContext;
